
import { images } from '../../img';

const i18n = require('!!amdi18n-loader!src/integration/nls/integration');


const templates = {
    'ally-files-accessibility-cell': require('./ally-files-accessibility-cell.handlebars'),
    'ally-files-accessibility-cell-new-files': require('./ally-files-accessibility-cell-new-files.handlebars'),
    'ally-files-accessibility-column-header': require('./ally-files-accessibility-column-header.handlebars'),
    'ally-files-accessible-versions-dropdown': require('./ally-files-accessible-versions-dropdown.handlebars'),
    // eslint-disable-next-line max-len
    'ally-files-accessible-versions-dropdown-new-files': require('./ally-files-accessible-versions-dropdown-new-files.handlebars'),
    'ally-files-accessible-versions-preview': require('./ally-files-accessible-versions-preview.handlebars'),
    'ally-files-accessible-versions-toolbar': require('./ally-files-accessible-versions-toolbar.handlebars'),
    'ally-files-accessible-versions-toolbar-new-files': require('./ally-files-accessible-versions-toolbar-new-files.handlebars'),
    'ally-files-modified-by': require('./ally-files-modified-by.handlebars'),
    'ally-files-preview-seizure': require('./ally-files-preview-seizure.handlebars'),
    'ally-files-seizure-indicator': require('./ally-files-seizure-indicator.handlebars'),
    'ally-files-seizure-indicator-new-files': require('./ally-files-seizure-indicator-new-files.handlebars'),
    'ally-files-time': require('./ally-files-time.handlebars'),
    'ally-prominent-icon-rich-content': require('./ally-prominent-icon-rich-content.handlebars'),
    'ally-user-content-dropdown': require('./ally-user-content-dropdown.handlebars'),
    'ally-user-content-image-container': require('./ally-user-content-image-container.handlebars'),
    'ally-user-content-prominent-icon': require('./ally-user-content-prominent-icon.handlebars'),
    'ally-user-content-icon-only': require('./ally-user-content-icon-only.handlebars')
};

export function apply(templateName, templateParams) {
    templateParams = templateParams || {};
    templateParams.i18n = templateParams.i18n || i18n;
    templateParams.images = templateParams.images || images;
    // ALLYPD-4318: The AF toolbar button might get removed. Ensure no extra whitespace is left by trimming all the HTML
    // templates
    return templates[templateName](templateParams).trim();
}
